module.exports = __webpack_public_path__ + "static/media/happy_hour_menu.0f787dd9.png";